export enum CustomMessageKey {
  top_fixed = 'top-fixed',
  top_overlay = 'top-overlay',
  local = 'local'
}
